import { FormRichTextEditor } from '@exam-management/rich-text-editor';

import { useUploadImageForQuestionReviewTask } from '../../hooks';
import { useQuestionReviewTaskQuestionDetails } from '../../providers';

export default function QuestionReviewResultDescriptionForm() {
  const { mainTaskDetails, question } = useQuestionReviewTaskQuestionDetails();

  const { handleUpload, loading: isLoading } = useUploadImageForQuestionReviewTask({
    taskId: mainTaskDetails.id,
    questionId: question.id,
  });

  return (
    <FormRichTextEditor
      name='description'
      label='ความเห็นเพิ่มเติม'
      placeholder='กรอกรายละเอียด'
      onImageUpload={handleUpload}
      loading={isLoading}
    />
  );
}
